type Row = { user_account_id: string; role_id: number; user_to_role_id: unknown };

export function SetRowLogic(rows: Row[]) {
  const groupedByUser = Object.groupBy(rows, (row) => row.user_account_id);

  return Object.entries(groupedByUser).map(([, userRows]) => {
    if (!userRows) return null;
    const roleIds = userRows.filter((row) => row.role_id).map((row) => row.role_id);

    const firstRow = userRows[0];

    return {
      ...firstRow,
      id: firstRow.user_account_id,
      role_id: roleIds,
      user_to_role_id: userRows.map((row) => ({
        [row.role_id]: row.user_to_role_id,
      })),
    };
  });
}
